/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';
import { AddButton, Buttons, DeleteButton, UpdateButton } from '../../components/Common/iComponents/iPopUp/IpopUp';
import Operations from '../../constants/operations';

import { Row, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import BasicPills from '../../components/Common/BasicPills/BasicPills';
import CommodityModal from '../../components/Common/iComponents/iCommodityModal/ICommodityModal';
import POcomparison from '../../components/Common/POComparision/POcomparison';
import ShowAttachments from '../../components/Common/ShowAttachments/ShowAttachments';
import { useDispatch } from 'react-redux';
import ShowInnoboDocuments from '../../components/Common/ShowInnoboDocuments/ShowInnoboDocuments';
import ChargesList from '../../components/Common/ChargesList/ChargesList';

const IForm = ({ selectedRow, milestoneConfig, groupName, onCreate, onUpdate, onDelete, columsPop = 4 }: any) => {
    const dispatch = useDispatch();
    const arrayUpdAdd = ['BuyerName', 'Number', 'company', 'description', 'enabled'];
    const toggleField = 'enabled';

    //const [listIsMilestones, setlistIsMilestones] = useState([{}]);
    const [form, setForm] = useState({ [toggleField]: false });
    const [optionSelect, setSelectOption] = useState<any>({});

    const [listVisibleInModalHeader, setlistVisibleInModalHeader] = useState([{}]);
    const [listVisibleInModalBody, setlistVisibleInModalBody] = useState([{}]);
    const [listVisibleInModalTotal, setlistVisibleInModalTotal] = useState([{}]);

    const [listVisibleInMiddle, setlistVisibleInMiddle] = useState([{}]);
    const [listVisibleInModalFooter, setlistVisibleInModalFooter] = useState([{}]);
    const [listIsMilestones, setlistIsMilestones] = useState([{}]);

    const [isPurchaseOrderView, setPurchaseOrderView] = useState<boolean>(false);

    const [isCommodityListView, setIsCommodityListView] = useState<boolean>(false);
    const [isPackingListView, setisPackingListView] = useState<boolean>(false);
    const [isAttachmentView, setIsAttachmentView] = useState<boolean>(false);
    const [tabPurchaseView, setTabPurchaseView] = useState<string>('1');
    const [isInvoicesListView, setIsInvoicesListView] = useState<boolean>(false);

    useEffect(() => {
        if (selectedRow) {
            setSelectOption(selectedRow);
            setForm(selectedRow);
        }
    }, [selectedRow]);

    useEffect(() => {
        const getAuthUser = localStorage.getItem('authUser');
        let user;
        if (getAuthUser) {
            user = JSON.parse(getAuthUser);
        }
        if (groupName === 'purchaseOrdersViewList') setPurchaseOrderView(true);
        if (groupName === 'commodityViewList') setIsCommodityListView(true);
        if (
            (groupName == 'whareHouseReceiptViewList' || groupName == 'cargoReleaseViewList') &&
            (user.NETWORK_ID == 37370 || user.NETWORK_ID == 36451)
        ) {
            setisPackingListView(true);
        }

        if(groupName === 'invoicesDataViewList'){
            setIsInvoicesListView(true);
            setIsCommodityListView(true);
        }

    }, [groupName]);
    useEffect(() => {
        if (milestoneConfig) {
            const middle = milestoneConfig.filter((x: { visibleInMiddle: boolean }) => x.visibleInMiddle === true);
            const modalBody = milestoneConfig.filter((x: { visibleInModalBody: boolean }) => x.visibleInModalBody === true);
            const modalFooter = milestoneConfig.filter((x: { visibleInModalFooter: boolean }) => x.visibleInModalFooter === true);
            const modalHeader = milestoneConfig.filter((x: { visibleInModalHeader: boolean }) => x.visibleInModalHeader === true);
            const modalTotal = milestoneConfig.filter((x: { visibleInModalTotal: boolean }) => x.visibleInModalTotal === true);
            const isMilestone = milestoneConfig.filter((x: { isMilestone: boolean }) => x.isMilestone === true);

            /*var result = selectedRow.find((obj: any) => {
        return listVisibleInModalHeader.contains( includes)
      });*/

            setlistVisibleInMiddle(processList(middle, selectedRow));
            setlistVisibleInModalBody(processList(modalBody, selectedRow));
            setlistVisibleInModalFooter(processList(modalFooter, selectedRow));
            setlistVisibleInModalHeader(processList(modalHeader, selectedRow));
            setlistVisibleInModalTotal(processList(modalTotal, selectedRow));
            setlistIsMilestones(processList(isMilestone, selectedRow));
        }
    }, [milestoneConfig]);

    const processList = (list: any[], selectedRow: any) => {
        const t: any[] = [];
        for (const item in selectedRow) {
            list.map(function (data: { dataField: string }, index: any) {
                if (data.dataField === item)
                    t.push({
                        ...data,
                        value: selectedRow[item],
                    });
                return data;
            });
        }

        return t;
    };

    const itemVals = (val: any, updateVal: any) => {
        for (const property in updateVal) {
            if (property === val) {
                return updateVal[property];
            }
        }
    };

    const renderButtons = () => (
        <Buttons>
            {selectedRow ? (
                <>
                    <DeleteButton type="button" className="btn btn-danger" onClick={() => onDelete(selectedRow.id)}>
                        Delete
                    </DeleteButton>
                    <UpdateButton className="btn" onClick={() => onUpdate(form)}>
                        Update
                    </UpdateButton>
                </>
            ) : (
                <AddButton type="submit" className="btn" onClick={() => onCreate(form)}>
                    Add
                </AddButton>
            )}
        </Buttons>
    );

    const renderModalHeader = () => {
        return (
            <React.Fragment>
                {listVisibleInModalHeader.length
                    ? listVisibleInModalHeader.map((item: any, key: any) => {
                        const { text, value } = item;
                        if (value != '' && value != null) {
                            return (
                                <div>
                                    <label className="labelModalHeader"> {text} </label>
                                    <label className="labelInfoModalHeader"> {value}</label>
                                </div>
                            );
                        }
                    })
                    : null}
            </React.Fragment>
        );
    };

    const renderInModalTotal = () => {
        return (
            <React.Fragment>
                <div>
                    {listVisibleInModalTotal.length
                        ? listVisibleInModalTotal.map((item: any, key: any) => {
                            const { text, value } = item;
                            if (value != '' && value != null) {
                                return (
                                    <label className="labelInfoModalTotal">
                                        {' '}
                                        {text} : {value}{' '}
                                    </label>
                                );
                            }
                        })
                        : null}
                </div>
            </React.Fragment>
        );
    };

    const renderInModalBody = () => {
        return (
            <React.Fragment>
                {listVisibleInModalBody.length
                    ? listVisibleInModalBody.map((item: any, key: any) => {
                        const { text, value } = item;
                        if (value != '' && value != null) {
                            return (
                                <div>
                                    <label className="labelModalBody"> {text} </label>
                                    <label className="labelInfoModalBody"> {value}</label>
                                </div>
                            );
                        }
                    })
                    : null}
            </React.Fragment>
        );
    };

    const renderInfo = () => {
        return (
            <>
                <Row className="upRown modalHeaderBackground">
                    <AvForm
                        className="custom-form mt-0"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                            gridAutoRows: 'minmax(10%, 60px)',
                            gridGap: '2%',
                            padding: '0',
                            textAlign: 'center',
                        }}
                    >
                        {listVisibleInModalHeader.length ? renderModalHeader() : null}
                    </AvForm>
                </Row>
                <Row className="MiddleRown isMilestoneBackground">
                    <BasicPills data={listIsMilestones} />
                </Row>

                <Row className="DownRown modalBodyBackground">
                    <AvForm
                        className="custom-form mt-0"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                            gridAutoRows: 'minmax(10%, 80px)',
                            gridGap: '2%',
                            padding: '0',
                        }}
                    >
                        {listVisibleInModalBody.length ? renderInModalBody() : null}
                    </AvForm>
                </Row>
                <Row
                    className="modalTotalBackground"
                    style={{
                        padding: '0',
                        textAlign: 'center',
                        maxHeight: 100,
                        overflow: 'auto',
                    }}
                >
                    {listVisibleInModalTotal.length ? renderInModalTotal() : null}
                </Row>
            </>
        );
    };

    return (
        <>
            <div className="formContainer">
                <div style={{ width: '100%' }}>
                    <Nav horizontal="end" tabs>
                        <NavItem>
                            <NavLink className={`${tabPurchaseView === '1' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('1')}>
                                <i className="bi bi-info-circle pe-1"></i> Info
                            </NavLink>
                        </NavItem>
                        {!isCommodityListView ? (
                            <NavItem>
                                <NavLink className={`${tabPurchaseView === '2' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('2')}>
                                    <i className="bi bi-info-circle pe-1"></i> Commodities
                                </NavLink>
                            </NavItem>
                        ) : null}

                        {isPurchaseOrderView && (
                            <>
                                <NavItem>
                                    <NavLink className={`${tabPurchaseView === '3' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('3')}>
                                        <i className="bi bi-boxes pe-1"></i> PO/WR Comparison
                                    </NavLink>
                                </NavItem>
                            </>
                        )}
                        <NavItem>
                            <NavLink className={`${tabPurchaseView === '4' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('4')}>
                                <i className="bx bx-file-blank pe-1"></i> Attachments
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={`${tabPurchaseView === '5' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('5')}>
                                <i className="dripicons-document"></i> My files
                            </NavLink>
                        </NavItem>

                        {isInvoicesListView && (
                            <NavItem>
                            <NavLink className={`${tabPurchaseView === '6' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('6')}>
                                <i className="dripicons-document"></i> Charges
                            </NavLink>
                        </NavItem>
                        )}
                        
                    </Nav>
                    <TabContent activeTab={tabPurchaseView} style={{ paddingBottom: '10px' }}>
                        <TabPane tabId="1">
                            {renderInfo()}
                        </TabPane>
                        <TabPane tabId="2">
                            <Row className="cursor-pointer">
                                {!isCommodityListView && tabPurchaseView == "2" ? <CommodityModal visiblePackingList={isPackingListView} SelectGuid={selectedRow} groupName={groupName}></CommodityModal> : null}
                            </Row>
                        </TabPane>
                        <TabPane tabId="3">
                            {tabPurchaseView == "3" ? (
                                <POcomparison selectedRow={selectedRow} milestoneConfig={milestoneConfig} isActive={tabPurchaseView === '3'} />
                            ) : null}
                        </TabPane>
                        <TabPane tabId="4">
                            {tabPurchaseView == "4" && groupName ? (
                                <ShowAttachments
                                    GUID={selectedRow.GUID ?? selectedRow.CLGUID}
                                    type={Operations.find((x: any) => x.OperationView === groupName)?.OperationType || ""}
                                    Number={selectedRow.Number ?? selectedRow.CLPartNumber}
                                    LayoutType={selectedRow.LayoutType}
                                />
                            ) : null}
                        </TabPane>
                        <TabPane tabId="5">
                            {tabPurchaseView == "5" && groupName && (selectedRow.GUID || selectedRow.CLGUID) ? (
                                <ShowInnoboDocuments
                                    GUID={selectedRow.GUID ?? selectedRow.CLGUID}
                                    type={Operations.find((x: any) => x.OperationView === groupName)?.OperationType || ""}
                                    Number={selectedRow.Number ?? selectedRow.CLPartNumber}
                                />
                            ) : null}
                        </TabPane>

                        <TabPane tabId="6">
                            <Row className="cursor-pointer">
                                {isInvoicesListView && tabPurchaseView == "6" ? (<ChargesList selectedRow={selectedRow} />)
                                
                                : null}
                            </Row>
                        </TabPane>

                    </TabContent>
                </div>
            </div>
        </>
    );
};

IForm.propTypes = {
    selectedRow: PropTypes.shape({
        Number: PropTypes.string,
        SellerName: PropTypes.string,
    }),
    milestoneConfig: PropTypes.shape({
        Number: PropTypes.string,
        SellerName: PropTypes.string,
        OperationName: PropTypes.string,
        OperationType: PropTypes.string,
        dataField: PropTypes.string,
        isMilestone: PropTypes.bool,
        order: PropTypes.string,
        text: PropTypes.string,
        userId: PropTypes.string,
        visibleInMiddle: PropTypes.bool,
        visibleInModalFooter: PropTypes.bool,
        visibleInModalHeader: PropTypes.bool,
        visibleInTable: PropTypes.bool,
        hidden: PropTypes.bool,
        visibleInModalBody: PropTypes.bool,
        visibleInModalTotal: PropTypes.bool,
    }),
    groupName: PropTypes.string,
    onCreate: PropTypes.func,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
    columsPop: PropTypes.number,
};

type Operations = {
    id?: number;
    Number?: string;
};

export default IForm;
